import { ReactNode } from "react";
import { ModalNew as Modal } from "components/Modal/ModalNew";
import { KeyPersonnel } from "pages/RFQ/RFQ/CreateRFQ/PreviewRFQ/Questionnaire/_components/KeyPersonnel";
import { ProjectExperienceCard } from "pages/RFQ/RFQ/CreateRFQ/PreviewRFQ/Questionnaire/_components/ProjectExperience";

type SmartFieldType = "project-experience" | "key-personnel";

interface SelectedModalContent {
	buttonText: string;
	modalContent: ReactNode;
	modalTitle: string;
}

interface SelectedValueModalProps {
	companyId: number;
	isOpen: boolean;
	questionId: number;
	selectedData: Record<string, unknown>[];
	type: SmartFieldType;
	onClose: () => void;
}

const getSelectedModalByType = (
	type: SmartFieldType,
	value: Record<string, unknown>[],
	companyId: number
): SelectedModalContent => {
	if (type === "key-personnel") {
		return {
			buttonText: "Selected Key Personnel",
			modalTitle: "Selected Key Personnel",
			modalContent: (
				<div className="grid grid-cols-2 gap-6 lg:grid-cols-3">
					{value.map((person) => {
						const id = person.id as number;
						return (
							<KeyPersonnel
								key={id}
								values={person as unknown as { id: number; [key: string]: unknown }}
								companyId={companyId}
								isPreview
								supplierSmartField
								className="min-w-[unset]"
							/>
						);
					})}
				</div>
			),
		};
	}
	return {
		buttonText: "Selected Projects",
		modalTitle: "Selected Project Experiences",
		modalContent: (
			<div className="grid grid-cols-2 gap-6 lg:grid-cols-3">
				{value.map((project) => {
					const id = project.id as number;
					return (
						<ProjectExperienceCard
							key={id}
							values={project as unknown as { id: number; [key: string]: unknown }}
							companyId={companyId}
							isPreview
							supplierSmartField
							className="min-w-[unset]"
						/>
					);
				})}
			</div>
		),
	};
};

const SelectedValueModal: React.FC<SelectedValueModalProps> = ({
	isOpen,
	onClose,
	type,
	questionId,
	companyId,
	selectedData,
}) => {
	const modalProps = getSelectedModalByType(
		type,
		selectedData || [],
		companyId
	);

	return (
		<Modal
			isOpen={isOpen}
			onClose={onClose}
			headerContent={modalProps.modalTitle}
		>
			{modalProps.modalContent}
		</Modal>
	);
};

export default SelectedValueModal;
